<script>
	import '$lib/domains/application/styles/app.css';

	import { PUBLIC_ENVIRONMENT } from '$env/static/public';

	import { browser, dev } from '$app/environment';
	import { inject } from '@vercel/analytics';

	import { Toasts } from '@ongrid/chassis';

	import * as Sentry from '@sentry/sveltekit';

	inject({ mode: dev ? 'development' : 'production' });

	if (browser) {
		Sentry.init({
			environment: PUBLIC_ENVIRONMENT,
			dsn: 'https://b7b55071e464cbdf406f76529a1e6b60@o4504163208921088.ingest.us.sentry.io/4506416452272128',
			debug: false,

			integrations: [
				Sentry.replayIntegration({
					networkDetailAllowUrls: [
						/^(https?:\/\/)?(?:[a-zA-Z0-9-]+\.)+ongrid\.app(?:\/.*)?$/, // https://apiv2.prod.foundation.ongrid.app/v1/vehicles/9c346670-a7c6-4ff0-bee6-36a0ef4cdba1
						/^https?:\/\/localhost:\d+\/(?:[^\/\s]+\/)*[^\/\s]+$/
					],
					networkRequestHeaders: ['X-Custom-Header'],
					networkResponseHeaders: ['X-Custom-Header']
				})
			],

			replaysSessionSampleRate: 0.1,
			replaysOnErrorSampleRate: PUBLIC_ENVIRONMENT === 'production' ? 1.0 : 0.0, // Remove noise from development
			tracesSampleRate: PUBLIC_ENVIRONMENT === 'production' ? 1.0 : 0.0 // Remove noise from development
		});
	}
</script>

<!-- We show Toasts at the highest layout level after authentication -->
<Toasts />

<div class="bg-pbg-400 text-textpbg-300">
	<slot />
</div>
